export const BlueOnionColors = {
    light: {
        background: 'linear-gradient(to right, #F2F3F7, #E6E7EB)',
        scope1: '#C2E1FF',
        scope2: '#3698FC',
        scope3: '#074183',
        emissionMitigation: '#FFBA4F',
        color1:"#17214F",
        color2: "#17214F",
        sideBarBackground: '#D9E2F2',
        sectionTitleColor:'#4B4B4B',
        listItemColor:'#4B4B4B',
        sectionTitleBackgroundColor: 'white',
        sectionTitleOutlineColor:'#DDDDE3',
        infoColor:'#6F7282',
        textFieldBackground:'#fffff',
        buttonColor:'#F0F8FF',
        buttonHoverColor:'#E7F4FF',
        buttonDisabledColor:'#F2F2F2',
        onBoardSideBar:'#F5F5FA',
        cardBackground: '#FFFFFF',
        cardBorder: '#E3E3E9',
        switchButtonColor: '#3698FC',
        sectionTextColor:'#27272A',
        bOSecondaryButton:"#E7F4FF",
        cardHeaderColor:'#F3F6F9',
        cardHeader:'#4B4B4B',
        backIcon:"#3698FC",
        tableBackground :"#F0F0F0",
        searchBarIcon:'#6F7282',
        searchBarBackground:'#ffffff',
        reportButton:"#3698fc",
        inActiveStepper:"#d9d9d9",
        emissionSwitchBackground:'#F0F0F0',
        verification: "#ffffff",
        activityLog: '#3698FB',
        // buttonHoverColor: "#d5e5f2",
        appRequestBackground: '#ffffff',
        emissionCancelButton:'#f0f8ff',
        emissionCancelHover:'#d8dfe6',
        sidebarSelectedBackgroundColor:"#0B74E5",
        sidebarSelectedContentColor:"#FFFFFF",
        checkBoxColor: "#3698FC",
        emissionCardColor:"white",
        footerText:"#4B4B4B",
        searchBarBorder:'#DDDDE3',
        searchBarHoverBorder: "#3698FC",
        cssName:'blueOnion',
        textFieldBorder:'#DDDDE3',
        activeTabBgColor : '#fff',
        regionCss:'blueOnionRegion',
        arrowLeftBackground:"#f0f8ff",
        leftArrowIcon: "#3698FC",
        radioIcon:"#3698FC",
        downLoadButton:"#f0f8ff",
        downLoadText:"#3698FC",
        reportTable:"#FBFBFF", //"#F2F3F7",
        OBTabBackground:"#fbfbff",
        OBTabBorderBottom:"#F0F0F0",
        selectedTab: "#ffffff",
        selectedTabBL:"null",
        selectedTabBorderBottom:"#DDDDE3",
        OBChildTabBackground:"#E7F4FF",
        groupReportChildTB:"#ffffff",
        timeLineBg: "#FBFBFF",
        dataEntryTabBackground:"#FFFFFF",
        dataEntryTabBorder:"#DDDDE3",
        paginationCardColor:"#F5F5FA",
        noColumnColor: '#FBFBFF',
        searchTextColor:'#4B4B4B',
        searchCloseIcon:'#6F7282',
        userManagementBackground: "#FFFFFF",
        reportGenerationBackground:'#fff',
        feedBackBackground:"#FFFFFF",
        tableRowHoverColor:'#fafafa'

      },
    dark: {
      background: 'linear-gradient(to right, #F2F3F7, #E6E7EB)',
        color1:"#17214F",
        color2: "#17214F",
        sideBarBackground: '#D9E2F2',
        sectionTitleColor:'#4B4B4B',
        listItemColor:'#4B4B4B',
        sectionTitleBackgroundColor: 'white',
        sectionTitleOutlineColor:'#DDDDE3',
        infoColor:'#6F7282',
        textFieldBackground:'#fffff',
        buttonColor:'#F0F8FF',
        buttonHoverColor:'#E7F4FF',
        buttonDisabledColor:'#F2F2F2',
        onBoardSideBar:'#F5F5FA',
        cardBackground: '#FFFFFF',
        cardBorder: '#E3E3E9',
        switchButtonColor: '#3698FC',
        scope1: '#C2E1FF',
        scope2: '#3698FC',
        scope3: '#074183',
        emissionMitigation: '#FFBA4F',
        progressBar: '#3698FC',
        progressBarBackground: '#E7F4FF',
        toggleBackground: '#1890FF',
        toggleCircle: '#FFFFFF',
        btnBackgroundBlue: '#3698FC',
        btnBackgroundAnother: '#EEEEF4',  
        btnText: "white",
        btnTextAnother: "black",
        bONavColor:'#0C124B',
        bOSectionFontFamily: 'Poppins',
        sectionTextColor:"red",
        bOPrimaryButton:"#3698FC",
        bOSecondaryButton:"#E7F4FF",
        cardHeaderColor:'#F3F6F9',
        cardHeader:'#4B4B4B',
        backIcon:"#3698FC",
        tableBackground :"#F0F0F0",
        searchBarIcon:'#6F7282',
        searchBarBackground:'#959CB6',
        reportButton:"#3698FC",
        inActiveStepper:"#d9d9d9",
        emissionSwitchBackground:'#F0F0F0',
        verification: "#ffffff",
        activityLog: '#3698FB',
        // buttonHoverColor: "#d5e5f2",
        appRequestBackground: '#ffffff',
        emissionCancelButton:'#f0f8ff',
        emissionCancelHover:'#d8dfe6',
        checkBoxColor: "#3698FC",
        emissionCardColor:"white",
        footerText:"#4B4B4B",
        searchBarBorder:'#DDDDE3',
        searchBarHoverBorder: "#3698FC",
        textFieldBorder:'#DDDDE3',
        activeTabBgColor : '#fff',
        regionCss:'blueOnionRegion',
        arrowLeftBackground:"#F0F8TF",
        leftArrowIcon: "#3698FC",
        radioIcon:"#3698FC",
        timeLineBg: "#FBFBFF",
        noColumnColor: '#FBFBFF',
        searchTextColor:'#C6C6C6',
        searchCloseIcon:'#C6C6C6',
        reportGenerationBackground:'#fff',
        tableRowHoverColor:'#fafafa'
  },
  
    fontFamily:"Poppins",
    textFieldSize:'14px',
    dropDownColor:"#4B4B4B",
    buttonText:'#3698FC',
    parentLevel:" #F0F8FF",
    parentText: "#3698FC",
    parentOutline: "#3698FC",
    facilityLevel: "#f8cbad",
    facilityOutline: "#959CB6",
    facilityText: "#4B4B4B",
    subsidiaryLevel: "#d0cece",
    subsidiaryText: "#4B4B4B",//"#5A5959",
    subsidiaryOutline: "#212529",
    connectionLine:"#959CB6",
    excelInfo:"#6F7282",
    activeSwitchColor:"#3698FB",
    inActiveSwitchColor: '#F0F0F0',
    inActiveTextColor: '#6F7282',
    inActiveEmissionColor: '#6F7282',
    switchOutline:'#F0F0F0',
    tableBottom:"#DDDDE3",
    downloadFontSize:'12px',
    appRequestOutline:'#DDDDE3',
    emissionButtonColor:"#3698fc",
    emissionButtonHover:"#2B70E1", //"#2b7fd4",
    emissionButtonDisabled:'#F2F2F2',
    emissionButtonText:"white",
    timeElapsedColor:'#3698FC',
    editProfileButton:'#F0F8TF',
    editProfileText:"#3698FC",
    editProfileHover:'#C3CCD6',
    disabledText:'#959cb6',
    noDataText:'#00000026',
    sendButton1: "#3698fc",
    sendButton2: "#3698fc",
    sendButton1Hover: "#2B70E1",
    sendButton2Hover: "#2B70E1",
    companyasAcolor: "#6F7282",
    activeColor: "#3698FB",
    infoIconFillColor: '#959CB6',
    addIconBgColor: "#3698FC",
    regionBoder: '#6F7282',
    menuListBackground: '#F0F8FF',
    menuListColor:'#3698FC',
    menuListHover:'#F5F5F5',
    splineColor:'#3698FC',
    barColor:'#ff7f0e',
    scope1ChartBackground:'#E7F4FF',
    scope2ChartBackground:'#F0F8FF',
    scope3ChartBackground:'#FBFBFB',
    smallUncertainty:"#C2E1FF",
    bigUncertainty:"#3698FC",
    smallUncertaintyText:"#4B4B4B",
    bigUncertaintyText:'#FFFFFF',
    groupReportTB:'#FFFFFF',
    groupReportText: '#4B4B4B',
    calendarIcon:'#959CB6',
    groupReportChildBorder:'1px solid #DDDDE3',
    groupReportBorder:"none",
    smallUncertaintyColor:"Light Blue",
    bigUncertaintyColor:"Blue",
  };
  
  export const BlueOnionInvertDark = (theme) => {
    return theme === "dark" ? "#6F7282" : "#6F7282";
  };

  export const BlueOnionLabel = (theme) => {
    return theme === "dark" ? "#4B4B4B" : "#4b4b4b";
  }

  export const BlueOnionTextFieldPlaceHolder =(theme) => {
    return theme === "dark" ? '#959cb6' : '#959cb6';
  }

  export const BlueOnionTextField = (theme) => {
    return theme === "dark" ? "#ffffff" : "#ffffff";
  }

  export const BlueOnionActiveText = (theme) => {
    return theme === "light" ? "#7eb2fa" : "#7eb2fa";
  }

  export const BlueOnionInActiveText = (theme) => {
    return theme === "light" ? "#6F7282" : "#6F7282";
  }
  export const BlueOnionActiveTab = (theme) => {
    return theme === "dark" ? "4px solid #3698FC" : "4px solid #3698FC";
  };

  export const BlueOnionAssetTab = (theme) => {
    return theme === "dark" ? "#fff" : "#fff";
  };

  export const BlueOnionModalBg = (theme) => {
    return theme === "dark" ? "#fff" : "#fff";
  };  